'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _require = require('lodash'),
    cloneDeep = _require.cloneDeep,
    pick = _require.pick,
    isNil = _require.isNil,
    getIn = _require.get,
    isUndefined = _require.isUndefined;

var _require2 = require('../../constants/endpointTypes'),
    endpointTypes = _require2.endpointTypes;

var resourceStatusStates = require('../../constants/resourceStatusStates');
var errorCodes = require('../../constants/errorCodes');
var errorMessages = require('../../constants/errorMessages');

var sharedLocationAttributes = ['coordinates', 'city', 'region', 'country', 'resolutionMethod'];
var sharedEndpointStatusAttributes = ['state', 'error', 'errorMessage'];
var sharedEndpointAttributes = ['endpointId', 'name', 'accountId', 'accountName', 'serviceId', 'deleted', 'endpointType'].concat(_toConsumableArray(sharedLocationAttributes.map(function (attr) {
    return 'location.' + attr;
})), _toConsumableArray(sharedEndpointStatusAttributes.map(function (attr) {
    return 'status.' + attr;
})), ['config.region', 'isPubliclyVisibleInDirectory']);

var generateStatus = function generateStatus() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref$state = _ref.state,
        state = _ref$state === undefined ? resourceStatusStates.OK : _ref$state,
        errorCode = _ref.errorCode,
        errorMessage = _ref.errorMessage,
        rest = _objectWithoutProperties(_ref, ['state', 'errorCode', 'errorMessage']);

    return _extends({
        state: state
    }, errorCode && { error: errorCode }, errorMessage && { errorMessage: errorMessage }, rest);
};

var getDevicesStatus = function getDevicesStatus(device) {
    var status = generateStatus();
    if (isNil(device)) {
        status = generateStatus({
            state: resourceStatusStates.ERROR,
            errorCode: errorCodes.endpointNoDevice,
            errorMessage: errorMessages.endpointNoDevice
        });
    } else if (device.activated !== true) {
        status = generateStatus({
            state: resourceStatusStates.ERROR,
            errorCode: errorCodes.endpointDeviceNotActivated,
            errorMessage: errorMessages.endpointDeviceNotActivated
        });
    } else if (isNil(device.iotConnected)) {
        status = generateStatus({
            state: resourceStatusStates.ERROR,
            errorCode: errorCodes.endpointMissingDeviceConnectivity,
            errorMessage: errorMessages.endpointMissingDeviceConnectivity
        });
    } else if (device.iotConnected === false) {
        status = generateStatus({
            state: resourceStatusStates.ERROR,
            errorCode: errorCodes.endpointDeviceNotConnected,
            errorMessage: errorMessages.endpointDeviceNotConnected
        });
    }
    return status;
};

var getRelaysStatus = function getRelaysStatus(relay) {
    var status = generateStatus();
    if (relay.activated !== true) {
        status = generateStatus({
            state: resourceStatusStates.ERROR,
            errorCode: errorCodes.endpointRelayNotActivated,
            errorMessage: errorMessages.endpointRelayNotActivated
        });
    } else if (isNil(relay.iotConnected)) {
        status = generateStatus({
            state: resourceStatusStates.ERROR,
            errorCode: errorCodes.endpointMissingRelayConnectivity,
            errorMessage: errorMessages.endpointMissingRelayConnectivity
        });
    } else if (relay.iotConnected === false) {
        status = generateStatus({
            state: resourceStatusStates.ERROR,
            errorCode: errorCodes.endpointRelayNotConnected,
            errorMessage: errorMessages.endpointRelayNotConnected
        });
    }
    return status;
};

var generateRolledUpEndpointStatus = function generateRolledUpEndpointStatus(_ref2) {
    var deviceStatus = _ref2.deviceStatus,
        relaysStatus = _ref2.relaysStatus;

    if (deviceStatus.state === resourceStatusStates.ERROR) {
        return deviceStatus;
    } else if (!isUndefined(relaysStatus) && relaysStatus.state === resourceStatusStates.ERROR) {
        return relaysStatus;
    } else {
        return generateStatus();
    }
};

var determineEndpointStatus = function determineEndpointStatus(endpoint) {
    if (endpoint.endpointType !== endpointTypes.SIGNIANT_DEVICES) {
        return generateStatus();
    }

    var device = getIn(endpoint, 'devices[0]');
    var deviceStatus = getDevicesStatus(device);
    var relay = getIn(endpoint, 'relays.groups[0].devices[0]');
    var relaysStatus = void 0;
    if (!isNil(relay)) {
        relaysStatus = getRelaysStatus(relay);
    }

    return _extends({}, generateRolledUpEndpointStatus({ deviceStatus: deviceStatus, relaysStatus: relaysStatus }), {
        components: _extends({
            devices: deviceStatus
        }, !isNil(relay) && { relays: relaysStatus })
    });
};

var filterSharedEndpoint = function filterSharedEndpoint(endpoint) {
    var endpointClone = cloneDeep(endpoint);

    var partnerStatus = getIn(endpointClone, 'status.state');
    if (partnerStatus === resourceStatusStates.ERROR) {
        endpointClone.status = generateStatus({
            state: resourceStatusStates.ERROR,
            errorCode: errorCodes.partnerEndpointError,
            errorMessage: errorMessages.partnerEndpointError
        });
    } else if (partnerStatus !== resourceStatusStates.OK) {
        endpointClone.status = generateStatus({
            state: partnerStatus,
            errorCode: errorCodes.partnerEndpointWarning,
            errorMessage: errorMessages.partnerEndpointWarning
        });
    }

    var filteredEndpoint = pick(endpointClone, sharedEndpointAttributes);
    return filteredEndpoint;
};

var mapEndpoint = function mapEndpoint(endpoint) {
    // Temporarily hide authId and userId related values, there is an issue in prod where we could reveal values from an incorrect account
    var endpointClone = cloneDeep(endpoint);
    var endpointStatus = determineEndpointStatus(endpoint);

    var mappedEndpoint = _extends({}, endpointClone, {
        status: endpointStatus
    });

    return mappedEndpoint;
};

var applyEndpointACL = function applyEndpointACL(accountId) {
    return function (endpoint) {
        var endpointClone = cloneDeep(endpoint);
        var mappedEndpoint = mapEndpoint(endpointClone);

        if (accountId !== endpoint.accountId) {
            var sharedEndpoint = filterSharedEndpoint(mappedEndpoint);
            return sharedEndpoint;
        }

        return mappedEndpoint;
    };
};

module.exports = {
    applyEndpointACL: applyEndpointACL
};